/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  ORACLEVote4Delegation,
  ORACLEVote4DelegationInterface,
} from "../ORACLEVote4Delegation";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContract",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "NFTContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "deadAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "delegateOfIds",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "delegateeList",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "gasReducer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getDelegateeList",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLengthOfDelegateeList",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_voter",
        type: "address",
      },
    ],
    name: "getVotable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_delegation",
        type: "address",
      },
    ],
    name: "getVoteOfDelegation",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getWinningDelegatee",
    outputs: [
      {
        internalType: "address[2]",
        name: "",
        type: "address[2]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftaddress",
        type: "address",
      },
    ],
    name: "setNFTcontract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IVault",
        name: "_vault",
        type: "address",
      },
    ],
    name: "setVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_val",
        type: "bool",
      },
    ],
    name: "setVotingState",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "state",
    outputs: [
      {
        internalType: "enum Vote4Delegation.State",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newDelegatee",
        type: "address",
      },
    ],
    name: "vote4Delegation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "weightOfDelegatee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ORACLEVote4DelegationConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ORACLEVote4DelegationConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ORACLEVote4Delegation__factory extends ContractFactory {
  constructor(...args: ORACLEVote4DelegationConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _nftContract: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ORACLEVote4Delegation> {
    return super.deploy(
      _nftContract,
      overrides || {}
    ) as Promise<ORACLEVote4Delegation>;
  }
  override getDeployTransaction(
    _nftContract: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_nftContract, overrides || {});
  }
  override attach(address: string): ORACLEVote4Delegation {
    return super.attach(address) as ORACLEVote4Delegation;
  }
  override connect(signer: Signer): ORACLEVote4Delegation__factory {
    return super.connect(signer) as ORACLEVote4Delegation__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ORACLEVote4DelegationInterface {
    return new utils.Interface(_abi) as ORACLEVote4DelegationInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ORACLEVote4Delegation {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ORACLEVote4Delegation;
  }
}
